"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CategoryCircuitForAdminEntity = void 0;
const category_circuit_entity_1 = require("./category-circuit.entity");
class CategoryCircuitForAdminEntity extends category_circuit_entity_1.CategoryCircuitEntity {
    number_of_displays;
}
exports.CategoryCircuitForAdminEntity = CategoryCircuitForAdminEntity;
